// TODO: The whole bankAccountValidation folder is based on the npm package "kontonummer"
// (https://www.npmjs.com/package/kontonummer) but due to importing issues (most likely due to
// outdated packages and node) I imported it statically and converted the files from TS to JS.
// This might cause trouble in the future due to it not being maintained, so best would be to
// try to fix these issues, but this solution will do for now.

export class KontonummerError extends Error {
  name = "KontonummerError";
}
